import { render, staticRenderFns } from "./PushButton.vue?vue&type=template&id=1c4845ea&scoped=true"
import script from "./PushButton.vue?vue&type=script&lang=js"
export * from "./PushButton.vue?vue&type=script&lang=js"
import style0 from "./PushButton.vue?vue&type=style&index=0&id=1c4845ea&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4845ea",
  null
  
)

export default component.exports